import React from 'react'
import { Link } from 'react-router-dom'

import Leadership from '../../static/images/icons/leadership.svg'
import Expertise from '../../static/images/icons/expertise.svg'
import Industry from '../../static/images/icons/industry.svg'
import Projects from '../../static/images/icons/projects.svg'
import Achievements from '../../static/images/icons/achievements.svg'

const Blocks = () => {
  return (
    <div className='section blocks'>
      <div className='container'>
        <div className='row'>
          <div
            className='col-xl-3 col-md-6 block'
            data-aos='fade-down'
            data-aos-delay='200'
          >
            <Link to='/leadership'>
              <img src={Leadership} />
              <div className='title'>Our Leadership</div>
            </Link>
          </div>

          <div
            className='col-xl-3 col-md-6 block'
            data-aos='fade-down'
            data-aos-delay='400'
          >
            <Link to='/expertise'>
              <img src={Expertise} />
              <div className='title'>Our Expertise</div>
            </Link>
          </div>

          <div
            className='col-xl-3 col-md-6 block'
            data-aos='fade-down'
            data-aos-delay='600'
          >
            <Link to='/about-us/industry'>
              <img src={Industry} />
              <div className='title'>Our Industry</div>
            </Link>
          </div>

          <div
            className='col-xl-3 col-md-6 block'
            data-aos='fade-down'
            data-aos-delay='800'
          >
            <Link to='/projects'>
              <img src={Projects} />
              <div className='title'>Our Projects</div>
            </Link>
          </div>

          <div
            className='col-xl-3 col-md-6 block'
            data-aos='fade-down'
            data-aos-delay='1000'
          >
            <Link to='/achievements-and-media'>
              <img src={Achievements} />
              <div className='title'>Achievements & Media</div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Blocks
